// Leaf module: imported by the route registry (pages/corporate/routes/review.ts),
// which is transitively pulled into _app via useNavigation. Keep this file free of
// component/hook imports so the registry stays light.
export enum ReviewCycleManagerTabsEnum {
  Active = 'active',
  Past = 'past',
}
